<template>
    <div >
      <img class="topimg" src="../assets/newimg/images/logo_03_03.png">
      <form>
        <div class="input-control">
          <input placeholder="输入设备号" v-model="iccid" />
          <img class="addon" v-if="wxReady" @click="handleScan" src="../assets/images/scan.png">
        </div>
        <template v-if="cardCheckOK==true && needAuth == 1 && binded==false">
          <div class="input-control">
            <input v-model="ruleForm.name" placeholder="使用人姓名" />
          </div>
          <div class="input-control">
            <input v-model="ruleForm.mobile" placeholder="输入手机号" />
            <span class="smscode" @click="handleSms">{{smsBtnTxt}}</span>
          </div>

          <div class="input-control">
            <input v-model="ruleForm.code"  placeholder="输入验证码" />
          </div>
        </template>

        <template v-else-if="binded==true && needAuth ==1 ">
          <div class="input-control">
            <input v-model="bindInfo.username" disabled placeholder="使用人姓名" />
          </div>
          <div class="input-control">
            <input v-model="bindInfo.mobile" disabled placeholder="输入手机号" />
          </div>
          <div style="font-size: .24rem;color: #000;">以上信息为此号码当前绑定的使用人信息，如有疑问，请联系客服</div>
        </template>
          <div class="btn" @click="handleCheckCard" v-if="cardCheckOK==false">查询</div>
          <div class="btn" @click="handleBindCard" v-else-if="binded==false">绑定</div>
          <div class="btn" @click="handleQueryCard" v-else-if="binded==true">确认</div>
      </form>
      <div class="tips">
        <div class="title">温馨提示：</div>
        <div>1：卡号为卡芯后的数字，短号为设备背面的字母和数字</div>
        <div>2：因产品实名使用之后，无法二次销售，故无法退卡</div>
        <div>3：绑卡时请核实该地区是否能使用，谨慎操作</div>
        <div>4：新疆、西藏、云南、港澳台不可使用!</div>
      </div>
      <van-dialog v-model="xieyimodal" :showConfirmButton="false">
        <div class="xieyibox" :style="{maxHeight: dialogHeight,overflowY: 'scroll'}">
          <div class="xy-title">特别提醒</div>
          <div class="xy-content">
            <div>您正在办理平台“物联网卡实名认证”业务,如果您点击页末“同意”按钮，您即将进入实名认证页面并向我司提供如下个人信息，所有产品和服务统一适用的一般性隐私条款，如我们的具体产品和服务单独的隐私政策与本政策有不一致的，以具体产品和服务单独的隐私政策为准。</div>
            <div>1、本人的身份证信息</div>
            <div>2、本人实名制联系电话</div>
            <div>本公司保证仅为向您提供物联网卡服务而收集:使用、存储您的个人信息。当您不再使用本公司物联网卡服务，我司将在法定期限内删除您的个人信息</div>
            <div>1、为您提供物联网卡的开通、使用、日常维护售后咨询服务</div>
            <div>2、向您提供物联网卡相关的优惠政策推送</div>
          </div>
          <div class="btn">
            <div @click="confirmxieyi">同意</div>
            <div @click="xieyimodal = false">取消</div>
          </div>
        </div>
      </van-dialog>
    </div>
</template>
<script>
    import wx from "weixin-js-sdk";
    export default {
        name: "bind",
        data() {
            return {
              xieyimodal:true,
                iccid: '',
                cardLengthCheck:false,
                errMsg: false,
                cardCheckOK:false,
                wxReady:false,
                sms:false,
                binded:false,
                bindInfo:{},
                needAuth:0,
                token:'',
              showList:false,
              dialogHeight:'',
                cardlist:[],
                smsBtnTxt:'发送验证码',
                ruleForm:{
                    iccid:'',
                    mobile:'',
                    name:'',
                    code:''
                }
            };
        },
        watch:{
            iccid(iccid){
                this.iccid = iccid.toUpperCase();
                this.cardCheckOK = false;
                this.needAuth = 0;
                this.binded = false
                if(this.iccid.indexOf('C') !== -1){
                    //移动卡二十位
                    if(this.iccid.length == 20 || (this.iccid.length >= 6 && this.iccid.length <= 10)){
                        this.cardLengthCheck = true
                    }else{
                        this.cardLengthCheck = false
                    }
                }else{
                    if(this.iccid.length == 19  || (this.iccid.length >= 6 || this.iccid.length <= 10)){
                        this.cardLengthCheck = true
                    }else{
                        this.cardLengthCheck = false
                    }
                }
            }
        },
      mounted() {
        this.dialogHeight= window.innerHeight *0.8+'px';
      },
      methods: {
            handleCheckCard(){
              let xieyi = localStorage.getItem('xieyi');
              if(!xieyi){
                this.xieyimodal = true
                return false
              }
                this.errMsg = '';
                this.cardCheckOK = false;
                this.binded = false;
                this.$toast.loading('查询中');
                localStorage.setItem("iccid",this.iccid)
                this.fetchData('/card/queryCard',{iccid:this.iccid},(res)=>{
                    this.$toast.clear();
                    if(res.code){
                        this.cardCheckOK = true
                        this.needAuth = res.data.needAuth
                        if(this.needAuth == 0) {
                            this.$router.push({name: 'index'})
                        }else if(res.data.mobile){
                            this.binded = true
                            this.bindInfo = res.data
                        }
                    }else{
                      if(res.url){
                        window.location.href = res.url
                        return;
                      }
                      this.$notify(res.msg);
                        this.errMsg = res.msg
                    }
                })
            },
            handleQueryCard(){
                this.$router.push({name:'index',query:{iccid:this.iccid}})
            },
            handleBindCard(){
                this.$toast.loading('绑定中')
                this.ruleForm.iccid = this.iccid
                this.fetchDataPost('/card/bind',this.ruleForm,(res)=>{
                    this.$toast.clear();
                    if(res.code){
                        this.$toast.success(res.msg);
                        this.$router.push({name:'index'})
                    }else{
                        this.$toast.fail(res.msg)
                    }
                })
            },
            initWechatJs(){
                let url = encodeURIComponent(location.href.split('#')[0])
                this.fetchData('/wechat/jssdk',{url:url},(res)=>{
                    if(res.code){
                        wx.config(res.data);
                        wx.ready(()=>{
                            this.wxReady = true;
                        })
                    }
                })
            },
            handleScan(){
                wx.scanQRCode({
                    needResult: 1,
                    scanType: ["barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                    success:(res)=>{
                        if(res.resultStr.includes(',')){
                            this.iccid = res.resultStr.split(',')[1];
                        }else {
                            this.iccid = res.resultStr;
                        }

                    }
                })
            },
            getCardListByOpenid(openid){
              this.fetchData('/card/querylist', {}, (res) => {
                console.log(res)
                if (res.code) {
                  for (var i in res.data) {
                    let card = res.data[i];
                    this.cardlist.push({
                      name: card.iccid,
                      value: card.iccid
                    })
                    if (card.default == 1) {
                      this.iccid = card.iccid;
                    }
                  }
                  if(!this.iccid && res.data && res.data[0]){
                    this.iccid = res.data[0].iccid
                  }
                }
              })
            },
            handleSms(){
                if(this.sms == false) {
                    this.sms = true
                    this.$toast.loading()
                    this.fetchData('/sms/send', {mobile: this.ruleForm.mobile}, (res) => {
                        this.$toast.clear();
                        if (res.code) {
                            this.$toast.success('发送成功')
                            let s = 60;
                            let intval = setInterval(()=>{
                                this.smsBtnTxt = s+'秒重发'
                                if(s <= 0){
                                    this.smsBtnTxt = '发送验证码';
                                    this.sms = false;
                                    clearInterval(intval);
                                }
                                s--;
                            },1000)

                        } else {
                            this.sms = false;
                            this.$toast.fail('发送失败')
                        }
                    })
                }
            },
          confirmxieyi(){
              localStorage.setItem('xieyi',1);
              this.xieyimodal = false
          }
        },
        created: function () {
            let xieyi = localStorage.getItem('xieyi');
            if(!xieyi) this.xieyimodal = true
            this.initWechatJs()
            if(this.$route.query.cardno){
                this.iccid = this.$route.query.cardno
            }else if(!this.$route.query.nostorage){
              this.iccid = localStorage.getItem("iccid");
            }
            if(this.iccid){
              if(this.$route.query.auto) {
                this.handleCheckCard()
              }
            }else if(!this.$route.query.nostorage){
              let openid = sessionStorage.getItem('token')
              if(!openid && this.$route.query.appid){
                this.$router.push({name: 'login',query:{appid:this.$route.query.appid,path:'/'}})
              }else if(openid){
                this.getCardListByOpenid(openid)
              }
            }

        }
    };
</script>
<style scoped lang="scss">
  .xieyibox{
    padding: .2rem .4rem;
    background: #fff;
    text-align: center;
    .btn{
      margin-top: .28rem;
      div{
        display: inline-block;
        width: 1.2rem;
        height: .6rem;
        text-align: center;
        line-height: .6rem;
        color: #fff;
        font-size: .28rem;
        border-radius: .2rem;
        background: rgb(254, 104, 113);
      }
      :last-child{
        margin-left: 1rem;
      }
    }
    .xy-title{
      letter-spacing: .1rem;
      color: rgb(254, 104, 113);
      font-size: .34rem;
      text-align: center;
      font-weight: bold;
      border-bottom: 1px dotted #eee;
      padding-bottom: .2rem;
    }
    .xy-content{
      padding-top: .2rem;
      text-align: left;
      div{
        text-indent: .34rem;
        font-size: .28rem;
        color: #000;
      }
    }
  }
  .tips{
    .title{
      line-height: 2;
      font-size: .3rem;
    }
    width: 6.2rem;
    margin: 1rem auto 0;
    color: #fff;
    font-size: .25rem;
    line-height: 1.6;
  }
  .topimg {
   width: 5rem;
    display:block;
    margin: 1rem auto;
  }
  form{
    font-size: .34rem;
    display: block;
    width: 6.2rem;
    margin: .2rem auto;
.btn{
  font-size: .36rem;
  width: 2.16rem;
  height: .56rem;
  line-height: .56rem;
  text-align: center;
  background: #28a8fa;
  border-radius: .4rem;
  color: #fff;
  margin: .4rem auto 0;
}
    .input-control{
      position: relative;
      width: 100%;
      height: .76rem;
      line-height: .76rem;
      background: #fff;
      margin-bottom: .6rem;
      input{
        display: block;
        width: 100%;
        height: 100%;
        background: #fff;
        border: none;
        text-indent: .4rem;
      }
      input[disabled]{
        background: #dfdfdf;
      }
      .addon{
        position: absolute;
        right: .1rem;
        top: .13rem;
        height: .5rem;
        width: .5rem;
      }
      .smscode{
        position: absolute;
        right: .1rem;
        top: .13rem;
        line-height: 1;
        padding: .1rem .2rem;
        border-radius: .2rem;
        color: #fff;
        background: #28a8fa;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/bind.vue